<nb-card style="width: 100%">
  <nb-card-header> Hardware Register </nb-card-header>
  <nb-card-body style="overflow-y: scroll">
    <div style="display: flex; flex-direction: column; gap: 15px">
      <p>This page lists all hardware currently available to this site. Hardware being returned can be marked as dispatched from here.</p>
      <button
        type="button"
        nbButton
        outline
        status="success"
        class="float-end"
        (click)="dispatchHardware()"
        nbTooltip="Click to start dispatching hardware back to Insurgo"
        nbTooltipPlacement="top"
        nbTooltipStatus="success"
        [disabled]="selectedDrivesCount === 0 && selectedScannersCount === 0"
      >
        Dispatch Selected Hardware to Insurgo
      </button>
      <div *ngIf="selectedDrivesCount > 0 || selectedScannersCount > 0">
        <strong>
          Selected Drives: {{ selectedDrivesCount }} | Selected Scanners:
          {{ selectedScannersCount }}
        </strong>
        <button
          type="button"
          nbButton
          outline
          status="warning"
          (click)="unselectAll()"
          [disabled]="selectedDrivesCount === 0 && selectedScannersCount === 0"
          size="x-small"
          nbTooltip="Clear all selections"
          nbTooltipPlacement="top"
          nbTooltipStatus="warning"
        >
          <nb-icon icon="refresh-outline"></nb-icon>
        </button>
      </div>
      <div>
        <hr />
        <h3>Drives ({{ onSiteDrivesTable.rowData.length }})</h3>
        <div class="d-flex justify-content-between">
          <div class="p-2">
            Page Size:
            <select
              [(ngModel)]="onSiteDrivesTable.desiredPaginationSize"
              (change)="onSiteDrivesTable.onPageSizeChanged()"
            >
              <option value="10" selected="">10</option>
              <option value="100">100</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
            </select>
          </div>
          <div class="p-2">
            <button
              nbButton
              status="warning"
              size="small"
              (click)="unselectAllDrives()"
              class="mx-3"
              [disabled]="selectedDrivesCount === 0"
            >
              Unselect All
              <nb-icon icon="refresh-outline"></nb-icon>
            </button>
            <button
              nbButton
              status="success"
              size="small"
              (click)="csvExportDrives()"
              class="mx-3"
              [disabled]="onSiteDrivesTable.rowData.length === 0"
            >
              CSV Export
              <nb-icon icon="external-link-outline"></nb-icon>
            </button>
          </div>
        </div>
        <ag-grid-angular
          #agGrid
          style="width: 100%"
          class="ag-theme-alpine ag-theme-alpine-compact"
          [rowData]="onSiteDrivesTable.rowData"
          [columnDefs]="onSiteDrivesTable.columnDefs"
          [context]="onSiteDrivesTable.context"
          [components]="onSiteDrivesTable.frameworkComponents"
          [defaultColDef]="onSiteDrivesTable.defaultColDef"
          [gridOptions]="onSiteDrivesTable.gridOptions"
          [enableCellTextSelection]="true"
          [rowSelection]="onSiteDrivesTable.rowSelection"
          [rowClassRules]="onSiteDrivesTable.rowClassRules"
          (gridReady)="onGridReady($event)"
          (firstDataRendered)="onSiteDrivesTable.headerHeightSetter()"
          (columnResized)="onSiteDrivesTable.headerHeightSetter()"
          [pagination]="true"
          [paginationPageSize]="onSiteDrivesTable.paginationPageSize"
          [paginationNumberFormatter]="
            onSiteDrivesTable.paginationNumberFormatter
          "
          [domLayout]="onSiteDrivesTable.domLayout"
        >
        </ag-grid-angular>
      </div>

      <div>
        <hr />
        <h3>Scanners ({{ onSiteScannersTable.rowData.length }})</h3>
        <div class="d-flex justify-content-between">
          <div class="p-2">
            Page Size:
            <select
              [(ngModel)]="onSiteScannersTable.desiredPaginationSize"
              (change)="onSiteScannersTable.onPageSizeChanged()"
            >
              <option value="10" selected="">10</option>
              <option value="100">100</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
            </select>
          </div>

          <div class="p-2">
            <button
              nbButton
              status="warning"
              size="small"
              (click)="unselectAllScanners()"
              class="mx-3"
              [disabled]="selectedScannersCount === 0"
            >
              Unselect All
              <nb-icon icon="refresh-outline"></nb-icon>
            </button>
            <button
              nbButton
              status="success"
              size="small"
              (click)="csvExportScanners()"
              class="mx-3"
              [disabled]="onSiteScannersTable.rowData.length === 0"
            >
              CSV Export
              <nb-icon icon="external-link-outline"></nb-icon>
            </button>
          </div>
        </div>
        <ag-grid-angular
          #agGrid
          style="width: 100%"
          class="ag-theme-alpine ag-theme-alpine-compact"
          [rowData]="onSiteScannersTable.rowData"
          [columnDefs]="onSiteScannersTable.columnDefs"
          [context]="onSiteScannersTable.context"
          [components]="onSiteScannersTable.frameworkComponents"
          [defaultColDef]="onSiteScannersTable.defaultColDef"
          [gridOptions]="onSiteScannersTable.gridOptions"
          [enableCellTextSelection]="true"
          [rowSelection]="onSiteScannersTable.rowSelection"
          [rowClassRules]="onSiteScannersTable.rowClassRules"
          (gridReady)="onGridReady($event)"
          (firstDataRendered)="onSiteScannersTable.headerHeightSetter()"
          (columnResized)="onSiteScannersTable.headerHeightSetter()"
          [pagination]="true"
          [paginationPageSize]="onSiteScannersTable.paginationPageSize"
          [paginationNumberFormatter]="
            onSiteScannersTable.paginationNumberFormatter
          "
          [domLayout]="onSiteScannersTable.domLayout"
        >
        </ag-grid-angular>
      </div>
    </div>
  </nb-card-body>
</nb-card>
